import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
//import { PTenantComponent } from './components/ptenant/ptenant.component';
import { TenantComponent } from './components/tenant/tenant.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { ProductComponent } from './components/product/product.component';
import { ContactComponent } from './components/contact/contact.component';
import { ClientsComponent } from './components/clients/clients.component';

const routes: Routes = [
	{ path: '', component:HomeComponent },
	//{ path: 'ptenant-registration/:id', component:PTenantComponent },
	{ path: 'tenant-registration/:id', component:TenantComponent },
	{ path: 'pricing', component:PricingComponent },
	{ path: 'product', component:ProductComponent },
	{ path: 'contact', component:ContactComponent },
	{ path: 'clients', component:ClientsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
